import React from 'react'
import { Button, Divider, Segment, Header, Grid } from 'semantic-ui-react'

import SimpleReactLightbox from "simple-react-lightbox";
import { SRLWrapper } from "simple-react-lightbox";

import edna27 from '../images/articlePictures/edna27.png'
import maizieEdnaJo31 from '../images/articlePictures/maizieEdnaJo31.png'
import edna41 from '../images/articlePictures/edna41.png'
import edna45 from '../images/articlePictures/edna45.png'
import clydeEdnaWedding from '../images/articlePictures/clydeEdnaWedding.png'
import frankKids79 from '../images/articlePictures/frankKids79.png'
import ednaClyde88 from '../images/articlePictures/ednaClyde88.png'
import clydeEdna96 from '../images/articlePictures/clydeEdna96.png'
import family07 from '../images/articlePictures/family07.png'
import edna08 from '../images/articlePictures/edna08.png'
import ednaBurial081 from '../images/articlePictures/ednaBurial081.png'
import ednaBurial08 from '../images/articlePictures/ednaBurial08.png'

const options = {
    thumbnails: {
        showThumbnails: false
    // buttons: {
    //   backgroundColor: "#1b5245",
    //   iconColor: "rgba(126, 172, 139, 0.8)",
    // },
    // caption: {
    //   captionColor: "#a6cfa5",
    //   captionFontFamily: "Raleway, sans-serif",
    //   captionFontWeight: "300",
    //   captionTextTransform: "uppercase",
    }
  };

const EdnaBio = () => (

<React.Fragment>
<Segment  style={{ padding: '0em 0em' }} vertical>
    <Grid celled='internally' columns='equal' stackable>
        <Grid.Row textAlign='center'>
            <Grid.Column  style={{ paddingBottom: '0em', paddingTop: '0em' }}>
                <br/>
                <Header as='h3' style={{ fontSize: '2em' }}>Edna Caroline Frank Richardson <br/> (1923 - 2008) </Header>
                <br/>

            </Grid.Column>
        </Grid.Row>

        <Grid.Row textAlign='left'>
            <Grid.Column  style={{ paddingBottom: '1em', paddingTop: '.5em' }} >
                <p class="sidePadding" style={{ fontSize: '1.33em' }}>
                <br/>
                Edna was born on March 25, 1923 in Brooklyn, New York. She was the baby of the family. She remembered having to wait downstairs every evening for Gus (her brother) to come home to ask for a penny. He usually gave her two, which she would use to buy a block of chocolate at the candy store.
                <br/>
                <br/>
                When she was 5, she got to see Charles Lindberg in a parade after his historic flight to Paris.
                <br/>
                <br/>
                Edna was always proud of the fact that her parents were born in the United States. Most of the parents of her friends, immigrated to the United States.
                <br/>
                <br/>
                <SimpleReactLightbox>
                    <SRLWrapper>
                    <div class="column">
                    {/* <SRLWrapper options={options}> */}
                    <img src={edna27} class="articlePhoto" alt="1927 -  Edna Frank" />
                    </div>
                <br/>
                Edna’s Mom took her and her siblings to the Hecksher Dental Clinic when they had to have their teeth worked on. It cost 10 cents a visit.
                <br/>
                <br/>
                Living on the streets of New York meant you had to be a fighter. Once when she was 7, she and her twelve-year old sister Maizie went to the park. A large twelve-year old Italian girl and her friends told her they couldn’t use their street. Maizie asked then “Why, was it their street and did they pay for it?” They replied yes and when asked how much, they said $100. The girl jumped Maizie and Edna jumped on the girls back and grabbed her around the neck. Both Maizie and Edna made a run for it and ran into their Minister who escorted them home.
                <br/>
                <br/>
                One of Edna’s favorite times was Friday nights. Her Aunt Helen used to bring Edna’s cousins, Helen &amp; Doris over for a visit. The kids would play and the sisters would talk.
                <br/>
                <br/>
                <div class="column">
                    {/* <SRLWrapper options={options}> */}
                    <img src={maizieEdnaJo31} class="articlePhoto" alt="1931 - Maizie, Edna, &amp; Jo Frank" />
                </div>
                <br/>
                Next door to the Frank’s was Harris’ Candy Store. The Frank’s bought candy, newspapers and other items there. The Harris’ daughter May was Josephine’s best friend and later Edna and May became close. Also the Harris’ had a phone there, the only one close by. The Franks used to get calls there. On January 26, 1946, she got a call from a soldier asking her for a date. She had to tell him she was getting married that day.
                <br/>
                <br/>
                Edna graduated from Bushwick High School in 1940. Later that year Edna took her Mother and Father to the World Fair. They went out to eat dinner and had a good time. This was the only time Edna went anywhere with just her parents.
                <br/>
                <br/>
                <div class="column">
                    {/* <SRLWrapper options={options}> */}
                    <img src={edna41} class="articlePhoto" alt="1941 - Edna" />
                </div>
                <br/>
                Just before the war, while she was at work in Manhattan, she saw Franklin Roosevelt drive by in a motorcade.
                <br/>
                <br/>
                On December 7, 1941, while Edna was at church, she heard people talking about Pearl Harbor being bombed by the Japanese.
                <br/>
                <br/>
                In the summer of 1942 Edna and her friend, Ethyl, took a train to Cape Cod, Massachusetts. Then they rode their bicycles to Boston. The first day they rode 25 miles. They spent three nights on road. They stayed in Hostels for $.25 per night. The second night they spent the night in a hayloft. When they reached Boston they spent the night at a friend of Ethyl’s. They stayed in Boston for a couple of days, and then Edna took the train back home. The whole trip was over 60 miles.
                <br/>
                <br/>
                On December 6, 1942, Edna went to the YWCA Central Service Canteen with her friend Monica. They were playing checkers when they heard a voice ask Monica if he could play Edna the next game. They had a pact that if a sailor or soldier spoke to one of them, the other disappeared. He could never understand how Monica disappeared so fast.
                <br/>
                <br/>
                Edna told him that she didn’t know his name and asked how he knew hers. He told her that he heard Monica call her Edna. They talked and he ended up escorting her home, where he asked her for a date. They met the next Thursday at the YWCA. While playing checkers, someone took their picture and a few months later it ended up on a YWCA brochure.
                <br/>
                <br/>
                Clyde lied about his age. He told Edna that he was 27. It wasn’t until months later, when she got her hands on his ID card that she found out just how old he was.
                <br/>
                <br/>
                When Clyde was in Brooklyn, they dated. They went to movies, bowling, walking and sometimes went to Manhattan or Coney Island. On Edna’s twenty-second birthday she got engaged. He sent the money and she bought the ring at Macy’s.
                <br/>
                <br/>
                Just before Christmas in 1944, Edna received a telegram from Clyde that said, “Pack your bags, because we are going to Florida.” Her Father hit the roof. Whenever she got into a fight with her Father, he would yell, “Why don’t you go marry your sailor?”
                <br/>
                <br/>
                Clyde sent Edna the money to take a train to Florida. She rode down by herself and Clyde, his sister Bertha and her husband, David, met her in Jacksonville. They drove to Gainesville where they spent the night. The next day they drove to Tampa and spent the night with Clyde’s Brother, Haskell Daniels and his wife Addie. The next day they drove to Fort Myers to visit Clyde’s Mother, Lucy. She spent three days in Fort Myers and then went back Tampa to catch a train back to Brooklyn.
                <br/>
                <br/>
                <div class="column">
                    {/* <SRLWrapper options={options}> */}
                    <img src={edna45} class="articlePhoto" alt="1944 - Edna on Sanibel Island" />
                </div>
                <br/>
                On her birthday, March 25, 1945, Clyde asked her what she wanted for her birthday. She pointed to her finger and said she wanted a wedding ring.
                <br/>
                <br/>
                On April 12, 1945, Edna arrived at the YWCA to hear that Franklin Roosevelt had just died. She and the other girls there spent the evening listening to the radio to keep up with the news. Everyone was kind of depressed.
                <div class="column">
                    {/* <SRLWrapper options={options}> */}
                    <img src={clydeEdnaWedding} class="articlePhoto" alt="1946 - Clyde &amp; Edna at their wedding " />
                </div>
                <br/>
                On January 26, 1946, Clyde and Edna married in Brooklyn. Joe Richards was the Best Man and Helen Frank was the Maid of Honor. They spent the night and the Pennsylvania Hotel in New York then took the train to Gainesville where they rented a house. The address was 650 West Court Street and the rent was $21 per month. It was a small two-bedroom house owned by Clyde’s brother in law, David Kite.
                <br/>
                <br/>
                In the beginning of her life in Florida, Edna was lonely. Everyday she would write a letter and walk across the street to the train station and put it on the Mail Train. Finally she told Clyde that she was either going to get a job or have a baby.
                <br/>
                <br/>
                For entertainment, Clyde and Edna would go eat at Wise’s Drug Store and then go to the Movies. Sometimes they would go to two. They also liked to buy a pint of ice cream and split it in half.
                <br/>
                <br/>
                Edna had a son, Kim, on May 10, 1947. She was in the hospital for nine days. The hospital cost $70. The Doctor cost $100 and the circumcision cost $10.
                <br/>
                <br/>
                In November of 1947 Edna went to New York to show off Kim and get him baptized on the 31st.
                <br/>
                <br/>
                Soon it cost a sliver of ice cream out of the pint for Kim. The sliver grew through the years.
                <br/>
                <br/>
                In August of 1950, Edna went to New York to go to her Father’s funeral.
                <br/>
                <br/>
                Their first vehicle was a 1939 Ford pick up truck.
                <br/>
                <br/>
                On October 7, 1954 Edna gave birth to Gail.
                <br/>
                <br/>
                On January 1, 1956, the family moved to 549 NE 12th Court, where they lived for more than 37 years.
                <br/>
                <br/>
                On March 16, 1958 Edna had Jay and on November 5, 1959 Edna had Karen.
                <br/>
                <br/>
                In July 1960 Edna took all four of her children to New York on the train. They stayed for a month with her sister, Jo and her family. They spent time with Helen, Nana, and the Richards. On Wednesday of each week they had dinner with her brother Gus and his wife Dottie.
                <br/>
                <br/>
                In the summer of 1962, Clyde drove the whole family to New York. They visited all of Edna’s family and stopped in Washington on the way back. They visited the Washington Monument, the Smithsonian and several other places of interest. They stopped at Mt Vernon on the way home.
                <br/>
                <br/>
                In April of 1975, Edna went to New York to visit her Mother and Sisters. When she returned she learned that her oldest Son, Kim, had moved to Houston.
                <br/>
                <br/>
                In May of 1976, Clyde and Edna went on a cruise to the Bahamas. The ship was the S.S. Emerald Seas of the Eastern Steamship Lines.
                <br/>
                <br/>
                In 1977, at the age of 54, Edna graduated from Santa Fe Community College.
                <br/>
                <br/>
                <div class="column">
                    {/* <SRLWrapper options={options}> */}
                    <img src={frankKids79} class="articlePhoto" alt="1979 - The Frank Kids. Gus, Helen, Josephine, Maizie, &amp; Edna" />
                </div>
                <br/>
                In the early 80’s Edna and Clyde began to buy University of Florida Football tickets.
                <br/>
                <br/>
                From April 8-22, 1983-Edna and her sister, Maizie flew to Europe for two-weeks. They started in London and went to Brussels, Colon, Heidelberg, Munich, Innsbruck, Venice, Florence, Rome, Milan, Geneva, and Paris.
                <br/>
                <br/>
                In April of 1985, Edna, Clyde and Karen drove to Houston for a week to visit Jay, Kim and their families.
                <br/>
                <br/>
                In 1988, Edna retired from the University of Florida after 29 years. After retirement she volunteered at the Alachua General Hospital for 12 years, until she and Clyde moved to Ocala. She was also a volunteer for the First Methodist Church.
                <br/>
                <br/>
                <div class="column">
                    {/* <SRLWrapper options={options}> */}
                    <img src={ednaClyde88} class="articlePhoto" alt="1988 - Edna &amp; Clyde" />
                </div>
                <br/>
                In March of 1989, Edna, Clyde and Karen traveled to Houston for their grandson’s (Kevin) first birthday and to see their granddaughter, Megan for the first time.
                <br/>
                <br/>
                In March of 1993, Edna celebrated her 70th birthday. Her sisters, Maizie and Jo came along with Pete, Maribeth and her children came to help celebrate it. Kim and his family drove over from Houston. There was a celebration on the tenth floor of a hotel in Gainesville. Her daughters, Gail and Karen, planned the party.
                <br/>
                <br/>
                On September 17, 1994, Edna and Clyde moved to 2817 NW 48th Terrace.
                <br/>
                <br/>
                On January 27, 1996, Edna &amp; Clyde celebrated the 50th Wedding Anniversary. Her Sister Maizie and nephew Pete was there and so was Clyde’s Sister-in-law Rita and Nephew Benny. All four of Edna’s children was also in attendance.
                <br/>
                <br/>
                <div class="column">
                    {/* <SRLWrapper options={options}> */}
                    <img src={clydeEdna96} class="articlePhoto" alt="1996 - January 27th. Clyde &amp; Edna" />
                </div>
                <br/>
                During the summer of 2000, Clyde and Edna moved to Ocala.
                 <br/>
                 <br/>
                Clyde fell on March 16, 2002 and broke his hip, after rehab at the Marion House he moved with Edna to Gail’s house where he died on August 5, 2002.
                <br/>
                <br/>
                In September of 2002, Edna and Karen drove to Pennsylvania to see her sister Helen. They also visited with Maribeth and her family.
                <br/>
                <br/>
                On October 20th, 2002, Edna flew with Jay to visit Kim and Jay’s families for two weeks.
                <br/>
                <br/>
                In March 2003, Edna drove to Houston with Kim, Carol and Kevin for a visit. She went to see the play, Kiss Me Kate with Kim and Carol. On Friday, the 21st, everyone went to Jay’s to celebrate her 80th birthday. She flew back to Florida on the 22nd where Gail and Donnie had a big birthday party for her in Gainesville with many of her friends and family.
                <br/>
                <br/>
                On May 10, 2007, Edna, with daughters Gail &amp; Karen and Grandchildren Marisa &amp; Autumn, surprised Kim on his 60th birthday.
                <br/>
                <br/>
                <div class="column">
                    {/* <SRLWrapper options={options}> */}
                    <img src={family07} class="articlePhoto" alt="2007 - May 13th. Marissa, Carol, Scott, Megan, Kevin, Gail, Kim, Edna, Kelly, Jay, Autumn, Karen, Lucille, &amp; Matt" />
                </div>
                <br/>
                On March 23, 2008 the family celebrated her 85th birthday. A party was held at Gail’s house. Kim &amp; Carol came from Texas to help celebrate.
                <br/>
                <br/>
                <div class="column">
                    {/* <SRLWrapper options={options}> */}
                    <img src={edna08} class="articlePhoto" alt="2008 - March 23. Edna's 85th Birthday" />
                </div>
                <br/>
                On April 6, 2008 Edna was taken to the Hospice House in Gainesville. She died at 12:40 PM on April 20, 2008. Gail &amp; Don Orth, Jerett Orth and Karen Richardson were at her side when she died.
                <br/>
                <br/>
                <div class="ui two column grid">
                <div class="column">
                    <img src={ednaBurial081} class="articlePhoto" alt="2008 – Edna's funeral" />
                </div>
                <div class="column">
                    <img src={ednaBurial08} class="articlePhoto" alt="2008 – Karen, Jay, Gail, &amp; Kim" />
                </div>
                </div>
                    </SRLWrapper>
                </SimpleReactLightbox>
                </p>
            </Grid.Column>
        </Grid.Row>
        </Grid>
    </Segment>
</React.Fragment>
)

export default EdnaBio